<template>
  <div id="app">
    <AppNavbar />
    <router-view v-slot="{ Component }">
      <transition name="page" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <AppFooter />
    <BackToTop />
    <CookieConsent />
  </div>
</template>

<script>
import AppNavbar from '@/components/layout/AppNavbar.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import BackToTop from '@/components/ui/BackToTop.vue'
import CookieConsent from '@/components/ui/CookieConsent.vue'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  name: 'App',
  components: { AppNavbar, AppFooter, BackToTop, CookieConsent },
  mounted() {
    AOS.init({
      duration: 800,
      easing: 'ease-out-quart',
      once: true,
      offset: 60,
    })
  }
}
</script>

<style>
@import '@/assets/css/main.css';

.page-enter-active,
.page-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.page-enter-from {
  opacity: 0;
  transform: translateY(12px);
}
.page-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>